import { render, staticRenderFns } from "./DvCorrelation.vue?vue&type=template&id=df479770&scoped=true&"
import script from "./DvCorrelation.vue?vue&type=script&lang=js&"
export * from "./DvCorrelation.vue?vue&type=script&lang=js&"
import style0 from "./DvCorrelation.vue?vue&type=style&index=0&id=df479770&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df479770",
  null
  
)

export default component.exports